import {
  Button,
  CheckSVG,
  constants,
  FlagHollowSVG,
  useModal,
  useWindowSize,
} from "@newsela/angelou";

import {
  actionNames,
  actionPrefixes,
  objectTypes,
  withTrackEvent,
} from "@newsela/snitch";
import { useState } from "react";
import ReportContentFormModal from "@/view/ReportContentFormModal";
import { featureButtonCss } from "./ReportGeneratedText.style";

interface ReportGeneratedTextProps {
  extraData?:
    | {
        target_language?: { code?: string; name?: string };
        text?: string;
        translation_identifier?: string;
      }
    | {
        standards?: string[];
        objective?: string;
      }
    | undefined;
  contentId: string;
  identifier?: string;
  reportSource: "LessonPlanner" | "Translate";
}

const ReportGeneratedText = ({
  extraData,
  contentId,
  identifier,
  reportSource,
}: ReportGeneratedTextProps) => {
  const ButtonWithTrackEvent = withTrackEvent(Button);

  const [isSubmitted, setIsSubmitted] = useState(false);
  const [reportContentModalProps, setReportContentModalActive, triggerRef] =
    useModal(false);
  const { width: windowWidth } = useWindowSize();
  const { sm } = constants.breakpoints.Breakpoints;
  const isMobile = windowWidth <= sm;

  const iconReport = isMobile
    ? {}
    : {
        icon: {
          SvgComponent: isSubmitted ? CheckSVG : FlagHollowSVG,
          alignment: Button.iconAlignments.left,
        },
      };

  const TRACKING_DATA = {
    Translate: {
      data_qa_selector: "report_translate_content",
      description: `User clicked to report translation in: ${identifier}`,
    },
    LessonPlanner: {
      data_qa_selector: "report_lesson_planner_content",
      description: `User clicked to report lesson planner in: ${contentId}`,
    },
  };

  return (
    <>
      <ButtonWithTrackEvent
        actionName={actionNames.flag}
        __cssFor={{ root: featureButtonCss }}
        dataProps={{
          "data-qa-selector": TRACKING_DATA[reportSource].data_qa_selector,
        }}
        flavor={Button.flavors.tertiary}
        onClick={() => setReportContentModalActive(true)}
        objectType={objectTypes.generatedTextAsset}
        actionPrefix={actionPrefixes.initiate}
        streamProperties={{
          content_type: "Article",
          description: TRACKING_DATA[reportSource].description,
          content_id: contentId,
        }}
        ref={triggerRef}
        {...iconReport}
      >
        {isSubmitted ? "Report submitted" : "Report content"}
      </ButtonWithTrackEvent>{" "}
      <ReportContentFormModal
        setIsSubmitted={setIsSubmitted}
        contentId={contentId}
        reportContentModalProps={reportContentModalProps}
        setReportContentModalActive={setReportContentModalActive}
        reportSource={reportSource}
        extraData={extraData || {}}
      />
    </>
  );
};

export default ReportGeneratedText;
